export const BooleanConverter = (value: string) => value === "true";
